export enum ACCESS {
  GENERAL = 'GENERAL',

  // User Module
  CREATE_USER = 'CREATE_USER',
  LIST_USERS = 'LIST_USERS',
  VIEW_USER = 'VIEW_USER',
  UPDATE_USER = 'UPDATE_USER',
  DELETE_USER = 'DELETE_USER',

  // User Module
  IMPORT_ACCOUNT = 'IMPORT_ACCOUNT',
  LIST_ACCOUNT = 'LIST_ACCOUNT',
  VIEW_ACCOUNT = 'VIEW_ACCOUNT',
  UPDATE_ACCOUNT = 'UPDATE_ACCOUNT',
  DELETE_ACCOUNT = 'DELETE_ACCOUNT',

  // Reward
  CREATE_REWARD = 'CREATE_REWARD',
  VIEW_REWARD = 'VIEW_REWARD',
  UPDATE_REWARD = 'UPDATE_REWARD',
  DELETE_REWARD = 'DELETE_REWARD',
  LIST_REWARD = 'LIST_REWARD',

  // Reward user
  VIEW_REWARD_USER = 'VIEW_REWARD_USER',
  UPDATE_REWARD_USER = 'UPDATE_REWARD_USER',
  DELETE_REWARD_USER = 'DELETE_REWARD_USER',
  LIST_REWARD_USER = 'LIST_REWARD_USER',
  // Special deal
  CREATE_SPECIAL_DEAL = 'CREATE_SPECIAL_DEAL',
  VIEW_SPECIAL_DEAL = 'VIEW_SPECIAL_DEAL',
  UPDATE_SPECIAL_DEAL = 'UPDATE_SPECIAL_DEAL',
  DELETE_SPECIAL_DEAL = 'DELETE_SPECIAL_DEAL',

  // Special deal user
  UPDATE_SPECIAL_DEAL_USER = 'UPDATE_SPECIAL_DEAL_USER',
  DELETE_SPECIAL_DEAL_USER = 'DELETE_SPECIAL_DEAL_USER',
  LIST_SPECIAL_DEAL_USER = 'LIST_SPECIAL_DEAL_USER',

  // Rating
  LIST_APP_RATING = 'LIST_APP_RATING',
  DELETE_APP_RATING = 'DELETE_APP_RATING',
  LIST_POST_RATING = 'LIST_POST_RATING',
  VIEW_POST_RATING = 'VIEW_POST_RATING',
  EXPORT_POST_RATING = 'EXPORT_POST_RATING',
  // Deleted User
  LIST_DELETED_USER = 'LIST_DELETED_USER',
  VIEW_DELETED_USER = 'VIEW_DELETED_USER',
  RESTORE_USER = 'RESTORE_USER',

  SEND_NOTIFICATION_TEMPLATE = 'SEND_NOTIFICATION_TEMPLATE',
  CREATE_NOTIFICATION_TEMPLATE = 'CREATE_NOTIFICATION_TEMPLATE',
  VIEW_NOTIFICATION_TEMPLATE = 'VIEW_NOTIFICATION_TEMPLATE',
  UPDATE_NOTIFICATION_TEMPLATE = 'UPDATE_NOTIFICATION_TEMPLATE',
  DELETE_NOTIFICATION_TEMPLATE = 'DELETE_NOTIFICATION_TEMPLATE',
  LIST_NOTIFICATION_TEMPLATE = 'LIST_NOTIFICATION_TEMPLATE',
  CREATE_NOTIFICATION = 'CREATE_NOTIFICATION',
  DELETE_NOTIFICATION = 'DELETE_NOTIFICATION',

  // Role Module
  LIST_ROLES = 'LIST_ROLES',
  LIST_PERMISSION = 'LIST_PERMISSION',
  CREATE_ROLE = 'CREATE_ROLE',
  VIEW_ROLE = 'VIEW_ROLE',
  UPDATE_ROLE = 'UPDATE_ROLE',
  DELETE_ROLE = 'DELETE_ROLE',

  // Media Module
  CREATE_MEDIA = 'CREATE_MEDIA',
  LIST_MEDIAS = 'LIST_MEDIAS',
  VIEW_MEDIA = 'VIEW_MEDIA',
  UPDATE_MEDIA = 'UPDATE_MEDIA',
  DELETE_MEDIA = 'DELETE_MEDIA',

  // Taxonomy module
  CREATE_TAXONOMY = 'CREATE_TAXONOMY',
  LIST_TAXONOMY = 'LIST_TAXONOMY',
  VIEW_TAXONOMY = 'VIEW_TAXONOMY',
  UPDATE_TAXONOMY = 'UPDATE_TAXONOMY',
  DELETE_TAXONOMY = 'DELETE_TAXONOMY',

  // Post module
  CREATE_POST = 'CREATE_POST',
  LIST_POST = 'LIST_POST',
  VIEW_POST = 'VIEW_POST',
  UPDATE_POST = 'UPDATE_POST',
  DELETE_POST = 'DELETE_POST',

  // Option module
  CREATE_UPDATE_OPTION = 'CREATE_UPDATE_OPTION',
  LIST_OPTION = 'LIST_OPTION',
  DELETE_OPTION = 'DELETE_OPTION',

  // Company module
  CREATE_COMPANY = 'CREATE_COMPANY',
  LIST_COMPANY = 'LIST_COMPANY',
  VIEW_COMPANY = 'VIEW_COMPANY',
  UPDATE_COMPANY = 'UPDATE_COMPANY',
  DELETE_COMPANY = 'DELETE_COMPANY',

  LIST_CONTEST = 'LIST_CONTEST',
  CREATE_CONTEST = 'CREATE_CONTEST',
  VIEW_CONTEST = 'VIEW_CONTEST',
}
